import styled from "styled-components";

const RecentBlogStyleWrapper = styled.section`
  padding: 0 0 110px 0; 
  background-color: #0d102d;

  .slider_items + .slider_items {
    margin-top: 20px;
  }

  .slick__slider__item {
    padding: 0 15px;
  }

  .blog_item_section{
    margin-top: 30px;
  }


  .view_btn {
    margin-top: 60px;
    margin-left: auto;
    margin-right: auto;
    background: transparent;
  }

  @media only screen and (max-width: 1280px) {
    .slider_items {
      .slick-list {
        margin: 0 -10px;
        .slick-slide {
          padding: 0 10px;
        }
      }
    }
  }

  @media only screen and (max-width: 667px) {
    padding: 0 0 80px 0;

    .view_btn {
      margin-top: 40px;
    }
  }

  @media only screen and (max-width: 480px) {
    padding: 0 0 60px 0;

    .view_btn {
      margin-top: 30px;
    }
  }
`;

export default RecentBlogStyleWrapper;
